import { Image } from "@genuin/ui/image";
import type { ComponentProps } from "react";

import { useBaseContext } from "@genuin/components/context/base";

type BrandSloganProps = ComponentProps<typeof Image>;

export function BrandSlogan({ ...props }: BrandSloganProps) {
  const { brandDetails } = useBaseContext();
  // Early return if brandDetails or slogan is not available
  if (!brandDetails?.slogan) {
    return null;
  }
  const { image, text, font } = brandDetails.slogan;

  // Check if we have valid content to display
  const hasValidImage =
    image && typeof image === "string" && image.trim() !== "";
  const hasValidText = text && typeof text === "string" && text.trim() !== "";
  // If neither image nor text is valid, don't render anything
  if (!hasValidImage && !hasValidText) {
    return null;
  }

  return (
    <div className="gencl:px-16 gencl:md:h-10! gencl:lg:h-12! gencl:flex gencl:justify-center gencl:h-full">
      {hasValidImage ? (
        <Image
          src={image}
          className="gencl:w-fit gencl:max-w-full"
          alt="Brand slogan"
          useWebp={false}
          handleError
          {...props}
        />
      ) : (
        <p
          className="gencl:text-center"
          style={{
            fontWeight: font?.weight?.trim() || "",
            fontFamily: font?.style?.trim() || "inherit",
          }}
        >
          {text}
        </p>
      )}
    </div>
  );
}
